export const ADD_DISHES = 'ADD_DISHES'
export const UPDATE_CARD_NOW = 'UPDATE_CARD_NOW'
export const ADD_OPTIONSETS = 'ADD_OPTIONSETS'
export const TOGGLE_EDIT = 'TOGGLE_EDIT'
export const ADD_SELECTED_OPTIONS = 'ADD_SELECTED_OPTIONS'
export const RESET_SELECTED_OPTIONS = 'RESET_SELECTED_OPTIONS'
export const ADD_SELECTED_DISH = 'ADD_SELECTED_DISH'
export const REMOVE_SELECTED_DISH = 'REMOVE_SELECTED_DISH'
